import {
  QueryHookOptions,
  RegisteredQuery,
  useLazyQuery,
  useQuery,
} from 'data-fetching-client';
import { useAppContext } from '../context/AppContext';

export function useAppContextQuery<
  TName extends string,
  TVariables extends Record<string, any>,
  TResponse,
>(args: {
  app: RegisteredQuery<TName, TVariables, TResponse>;
  public: RegisteredQuery<TName, TVariables, TResponse>;
  options?: QueryHookOptions<Record<TName, TResponse>, TVariables>;
}) {
  const query = useAppContext() === 'app' ? args.app : args.public;
  return useQuery(query, args.options);
}

export function useLazyAppContextQuery<
  TName extends string,
  TVariables extends Record<string, any>,
  TResponse,
>(args: {
  app: RegisteredQuery<TName, TVariables, TResponse>;
  public: RegisteredQuery<TName, TVariables, TResponse>;
  options?: QueryHookOptions<Record<TName, TResponse>, TVariables>;
}) {
  const query = useAppContext() === 'app' ? args.app : args.public;
  return useLazyQuery(query, args.options);
}
